import type { Term } from "./types";

function norm(id: string | null | undefined): string {
  return (id ?? "").trim().toLowerCase();
}

export function termIsStaffAuthored(
  term: Term,
  staffUserId: string | null | undefined
): boolean {
  if (term.isAdminAuthored === true) {
    return true;
  }
  if (term.isAdminAuthored === false) {
    return false;
  }
  const sid = norm(staffUserId);
  const uid = norm(term.user_id);
  if (sid.length > 0 && uid.length > 0 && sid === uid) {
    return true;
  }
  return false;
}

/** Terms that belong in “All Contributions” — excludes Word Master / staff-originated rows when detectable. */
export function contributorSubmissions(
  terms: Term[],
  staffUserId: string | null | undefined
): Term[] {
  return terms.filter(t => !termIsStaffAuthored(t, staffUserId));
}
